module.exports = __webpack_public_path__ + "static/b.9ccb7a7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./res/TopGallery/b.jpg
// module id = 290
// module chunks = 114276838955818